// 开发
// let baseUrl='http://172.23.0.73:9999'
// 生产
// let baseUrl = 'http://171.217.92.33:9999'
let baseUrl = "https://hncy.info";

let obName = "/oa";

let API = {
  api: {
    //分页获取文章
    articl: baseUrl + obName + "/optima/hp/hpArticle/getArticles",
    news: baseUrl + obName + "/optima/hp/hpArticle/getNewArticles",
    articlDetail: baseUrl + obName + "/optima/hp/hpArticle/getArticle",
    articlPre: baseUrl + obName + "/optima/hp/hpArticle/getArticleBefore", //获取上一篇
    articlNext: baseUrl + obName + "/optima/hp/hpArticle/getArticleAfter", //获取下一篇
    banner: baseUrl + obName + "/optima/hp/hpSlideShow/getSlideShow",
    phone: baseUrl + obName + "/optima/hp/hpJobApply/checkCanSave",
    saveForm: baseUrl + obName + "/optima/hp/hpJobApply/saveJobApply",
    downloadBook: baseUrl + obName + "/optima/hp/hpWebBook/getLatestBook",
    getBook: baseUrl + obName + "/optima/hp/hpWebBook/getBook",
    video: baseUrl + obName + "/optima/hp/hpArticle/getVideo",
    homeVideo: baseUrl + obName + "/optima/hp/hpArticle/getHomeVideo",

    getEmployments: baseUrl + obName + "/optima/hp/hpEmployment/getEmployments",
    addOrderOperation:
      baseUrl + obName + "/optima/hp/hpOrderOperation/addOrderOperation",
    getArticles: baseUrl + obName + "/optima/hp/hpArticle/getArticles",
    getHpAiNum: baseUrl + obName + "/optima/hp/hpAiNum/getAiNum" //获取 AI 动态数据
  }
};
export default {
  API: API,
  baseUrl: baseUrl,
  obName
};



// WEBPACK FOOTER //
// ./src/api/url.js